export const THREAD_PAGES_PRELOAD_EVENT = 'pplx:ask:preload-thread-pages';
export function emitThreadPagesPreload(target) {
    window.dispatchEvent(new CustomEvent(THREAD_PAGES_PRELOAD_EVENT, { detail: target }));
}
export function listenForThreadPagesPreload(listener) {
    const eventListener = (event) => listener(event.detail);
    window.addEventListener(THREAD_PAGES_PRELOAD_EVENT, eventListener);
    return () => window.removeEventListener(THREAD_PAGES_PRELOAD_EVENT, eventListener);
}
//# sourceMappingURL=threadPagesPreloadEvent.js.map